export type GetCenteredCropBoxForSizeParams = {
  imageHeight: number;
  imageWidth: number;
  targetHeight: number;
  targetWidth: number;
};

export type CenteredCropBox = {
  height: number;
  width: number;
  x: number;
  y: number;
};

/** Crop must not upscale the source image, so oversized targets are fitted down first. */
export const getCenteredCropBoxForSize = ({
  imageHeight,
  imageWidth,
  targetHeight,
  targetWidth,
}: GetCenteredCropBoxForSizeParams): CenteredCropBox => {
  const fitScale = Math.min(1, imageWidth / targetWidth, imageHeight / targetHeight);
  const width = (targetWidth * fitScale) / imageWidth;
  const height = (targetHeight * fitScale) / imageHeight;

  return {
    height,
    width,
    x: (1 - width) / 2,
    y: (1 - height) / 2,
  };
};
